module.exports = __webpack_public_path__ + "static/media/chuancheng.3c483056.png";